<template>
	<el-dialog class="elDialog" width="550px" :visible.sync="visible" title="企业账户退款" :close-on-click-modal="false"
		:close-on-press-escape="false">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
			label-width="120px">

			<el-row class="el-form-item el-form-item--default">
				<el-col class="el-form-item__label" :span="8" style="text-align: left;padding-left: 40px;">我方主体名称
				</el-col>
				<el-col class="el-form-item__label" :span="16" style="text-align: right;padding-right: 65px;">
					{{dataForm.bodyName}}
				</el-col>
			</el-row>

			<el-row class="el-form-item el-form-item--default">
				<el-col class="el-form-item__label" :span="8" style="text-align: left;padding-left: 40px;">收款方名称
				</el-col>
				<el-col class="el-form-item__label" :span="16" style="text-align: right;padding-right: 65px;">
					{{dataForm.name}}
				</el-col>
			</el-row>
			<el-row class="el-form-item el-form-item--default">
				<el-col class="el-form-item__label" :span="8" style="text-align: left;padding-left: 40px;">账户余额</el-col>
				<el-col class="el-form-item__label" :span="16" style="text-align: right;padding-right: 65px;">
					{{dataForm.balance}}
				</el-col>
			</el-row>

			<el-row class="el-form-item el-form-item--default" style="display: inline-flex;">
				<el-col class="el-form-item__label">
					<el-form-item label="退款金额" prop="refundBalance">
						<el-input v-model="dataForm.refundBalance" placeholder="退款金额"
							style="     width: 200px;    margin-left: 135px;  text-align: right;height: 35px;line-height: 35px;">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col class="el-form-item__label" :span="3" style="text-align: left;">
					<el-button type="text" size="small" @click="allClick()">
						全部金额
					</el-button>
				</el-col>
			</el-row>
			<el-row class="el-form-item el-form-item--default">
				<el-col class="el-form-item__label">
					<el-form-item label="支付密码" prop="password">
						<el-input placeholder="支付密码" v-model="dataForm.password" type="password"  autocomplete="new-password"
							style="width: 200px; margin-left:135px; height: 35px; line-height: 35px;    text-align: right;">
						</el-input>
					</el-form-item>
        </el-col>
			</el-row>
		</el-form>
		<template slot="footer">
			<el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
		</template>
	</el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  isEmail,
  isMobile
} from '@/utils/validate'
export default {
  data () {
    return {
      visible: false,
      roleList: [],
      roleIdListDefault: [],
      dataForm: {
        id: '',
        refundBalance: '',
        password: ''

      }
    }
  },
  computed: {
    dataRule () {
      return {
        refundBalance: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/sys/spdb/accountInfo', {
        params: {
          id: this.dataForm.id
        }
      }).then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        console.log(this.dataForm)

        this.dataForm.deactivate = (res.data.status == 0 ? 'yes' : 'no')
      }).catch(() => {})
    },
    allClick () {
      this.dataForm.refundBalance = this.dataForm.balance
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.dataForm.refundBalance > this.dataForm.balance) {
          return this.$message.error('退款余额不能大于账户余额')
        }
        let url = '/sys/spdb/refund'
        this.$http.post(url, {
          ...this.dataForm
        }).then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, {
      'leading': true,
      'trailing': false
    })
  }
}
</script>

<style lang="scss" scoped>
	.mod-sys__user {
		.dept-list {

			.el-input__inner,
			.el-input__suffix {
				cursor: pointer;
			}
		}

		.role-list {
			.el-select {
				width: 100%;
			}
		}
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-input {
		display: block;
	}

	.el-form-item__error {
		top: 30%;
		left: 45px;
	}

	.elDialog .el-dialog__header {
		padding: 23px 39px;
		border-bottom: 1px solid #D1D1D1;
	}

	.el-form-item {
		.el-input__inner {
			text-align: right;
		}
	}

	.elDialog .el-dialog__body {
		border-bottom: 1px solid #D1D1D1;
	}
</style>
